import React from 'react';
import { t } from '@lingui/core/macro';

import { Heading, Paragraph } from '@rover/kibble/core';
import Section from '@rover/kibble/patterns/Section';
import Accordion from '@rover/react-lib/src/components/lists/Accordion';
import { BrandLocalityServiceCitiesItem } from '@rover/rsdk/src/apiClient/latest/model/brandLocalityServiceCitiesItem';
import { CountryFooterLink } from '@rover/rsdk/src/apiClient/latest/model/countryFooterLink';
import { PaginatedCountryRegionLinkList } from '@rover/rsdk/src/apiClient/latest/model/paginatedCountryRegionLinkList';

import CitiesAndNeighborhoodsLinks from './CitiesAndNeighborhoodsLinks';
import CountriesLinks from './CountriesLinks';
import CountryRegionLinks from './CountryRegionLinks';
import FactCitations, { Citation } from './FactCitations';

export type FooterProps = {
  countryRegionLinks: PaginatedCountryRegionLinkList;
  countryFooterLinks?: CountryFooterLink[];
  citiesAndNeighborhoodsLinks?: BrandLocalityServiceCitiesItem[];
  citations?: Citation[];
};

const Footer = ({
  citiesAndNeighborhoodsLinks,
  countryRegionLinks,
  countryFooterLinks,
  citations,
}: FooterProps): JSX.Element => {
  return (
    <Section background="contrast" py="12x">
      <Heading
        webProps={{ as: 'h3', responsive: true }}
        mb="2x"
        size="400"
        textColor="secondary_inverse"
      >
        {t`A world of trusted pet care.`}
      </Heading>
      <Paragraph mb="12x" textColor="secondary_inverse">
        {t`Explore our selection of dedicated sitters both nationally and internationally.`}
      </Paragraph>

      <Accordion itemColorVariant="primary_inverse" headingSize="200">
        {citiesAndNeighborhoodsLinks && (
          <CitiesAndNeighborhoodsLinks citiesAndNeighborhoodsLinks={citiesAndNeighborhoodsLinks} />
        )}

        {!!(
          countryRegionLinks.results &&
          countryRegionLinks.countryFlag &&
          countryRegionLinks.countryName
        ) && (
          <CountryRegionLinks
            countryRegionLinks={countryRegionLinks.results}
            countryName={countryRegionLinks.countryName}
            countryFlag={countryRegionLinks.countryFlag}
          />
        )}
        {countryFooterLinks && <CountriesLinks countryFooterLinks={countryFooterLinks} />}
        {citations && <FactCitations citations={citations} />}
      </Accordion>
    </Section>
  );
};

export default Footer;
